import cascaderAddress from './cascader-address';
import basicContainer from '@vue-materials/basic-container'
import selectInput from './select-input'
import imgUpload from './img-upload'
import selector from './selector'
import mapAddress from './map-address'
import auditDialog from './auditDialog'
import getGoodsTime from './get-goods-time'
import bindModifyPhone from './bind-modify-phone'
import fuzzyQuery from './fuzzyQuery'
import storeTypes from './storeTypes'
import staticSelector from './static-selector'
import storeImgUpload from './storeImgUpload'

const components = [
  cascaderAddress,
  basicContainer,
  selectInput,
  imgUpload,
  selector,
  mapAddress,
  auditDialog,
  getGoodsTime,
  bindModifyPhone,
  fuzzyQuery,
  storeTypes,
  staticSelector,
  storeImgUpload
]

const install = function(Vue, opts = {}) {
  components.forEach(component => {
    Vue.component(component.name, component);
  });
};

export default {
  install,
  cascaderAddress,
  basicContainer,
  selectInput,
  imgUpload,
  selector,
  mapAddress,
  auditDialog,
  getGoodsTime,
  bindModifyPhone,
  fuzzyQuery,
  storeTypes,
  staticSelector,
  storeImgUpload
};

